<template>
  <div>
    <div class="content mb10">
      <div class="bottom-line">
        <h3 class="common-title require-field mb10">首先， 填写客户公司、岗位名称等【必填信息*】</h3>
        <div class="display-flex mb15">
          <div class="tip-text-left align-center display-flex">
            <span class="field-label"> <span class="require-field">*</span>客户公司 </span>
            <el-autocomplete
              v-model="project.客户公司"
              class="field-value"
              size="mini"
              :fetch-suggestions="querySearch"
              placeholder="请输入公司简称"
              :disabled="hasCreated"
              @select="handleSelect"
            >
              <template slot-scope="{ item }">
                <span :class="{ 'blue-text': item.value === '没找到，新建一家公司' }">{{ item.value }}</span>
              </template>
            </el-autocomplete>
          </div>
          <div class="tip-text-right"><p class="tip-text">1、可输入公司简称或全名均可搜索；</p></div>
        </div>
        <div class="display-flex mb15">
          <!-- TODO: 改名还是写错了  项目名称、岗位名称 -->
          <span class="field-label"> <span class="require-field">*</span>岗位名称 </span>
          <el-input
            v-model="project.项目名称"
            :disabled="hasCreated"
            class="field-value"
            size="mini"
            placeholder="请输入岗位名称"
          ></el-input>
        </div>
      </div>

      <div class="bottom-line">
        <h3 class="common-title mb10">客户独家或保密职位，请勾选，项目会特殊标记，提醒顾问</h3>
        <div class="bottom-line">
          <el-checkbox v-model="project.保密">保密职位</el-checkbox>
          <el-checkbox v-model="project.独家">独家职位</el-checkbox>
        </div>
        <div class="display-flex align-center mb15">
          <span class="field-label">优先级</span>
          <el-rate v-model="project.优先级" :colors="colors"></el-rate>
        </div>
        <div class="display-flex align-center mb15">
          <span class="field-label">办公地点</span>
          <!-- <el-select
            v-model="project['办公地']"
            multiple
            filterable
            allow-create
            placeholder="填写办公地点，可多选"
            size="mini"
            class="field-value"
          >
            <el-option v-for="(value, i) in locations" :key="i" :value="value" :label="value" />
          </el-select>-->
          <iconSelect
            v-model="project['办公地']"
            class="field-value"
            placeholder="填写办公地点，可多选"
            :options="locations"
          >
            <i slot="icon" class="el-icon-s-grid" @click="toChooseCity"></i>
          </iconSelect>
        </div>

        <div class="display-flex align-center mb15">
          <span class="field-label">用人部门</span>
          <el-input v-model="project.部门" class="field-value" size="mini" placeholder="请输入部门名称"></el-input>
        </div>
        <div class="display-flex align-center mb15">
          <span class="field-label">职能模块</span>
          <el-select v-model="project.职能模块" class="field-value" filterable size="mini" placeholder="请输入职能模块">
            <el-option v-for="(value, i) in categories" :key="i" :value="value.名称" :label="value.名称" />
          </el-select>
          <el-tooltip effect="light" content="根据行业选择职能模块，多选；" placement="right">
            <i class="el-icon-question ml10" style="color:#409EFF"></i>
          </el-tooltip>
        </div>
        <div class="display-flex align-center mb15">
          <div class="tip-text-left display-flex align-center">
            <span class="field-label">预计第一批人推荐时间</span>
            <el-date-picker
              v-model="project.indroduceTime"
              type="date"
              size="mini"
              value-format="timestamp"
              class="field-value"
              :picker-options="pickerOptions"
            />
          </div>
          <div class="tip-text-right">
            <p class="tip-text">非必填，如果客户经理填写时间，到时系统会自动提醒项目相关操作人员。</p>
          </div>
        </div>
      </div>

      <div class="display-flex">
        <div class="tip-text-left">
          <h3 class="common-title mb10">选择该项目的负责人以及执行人员</h3>
          <div class="mb10">
            <div v-for="type in partnerField" :key="type" class="flex-row align-center mb15">
              <div class="col-0 propject_detail_info_label mr10">{{ type }}</div>
              <div class="col-1 flex-row flex-wrap flex_wrap_container">
                <div v-for="(item, index) in project[type]" :key="index" class="flex_wrap_item">
                  <el-select v-model="project[type][index]" filterable size="mini" @change="selectPartnet(type)">
                    <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
                  </el-select>
                  <a class="col-0 mr5 danger" @click="removePartner(type, index)"> <i class="el-icon-remove" /> </a>
                  <a v-if="index === project[type].length - 1" class="col-0 mr5" @click="addPartner(type)">
                    <i class="el-icon-circle-plus" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip-text-right">
          <p class="tip-text">
            <span>1、填写项目的负责人及执行人员，系统会自动发送微信通知；</span> <br />
            <span>2、项目对接未填写会默认为创建项目的人员；</span> <br />
            <span>3、若不填项目经理、项目成员，则该项目自动归为待认领状态；</span> <br />
            <span>
              <i class="el-icon-warning mb10"></i>不了解各职能模块负责人请点击
              <el-button type="primary" plain size="mini">查看职能模块负责人</el-button>
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="handle-buttons">
      <el-button v-if="!hasCreated" type="primary" size="mini" @click="confirm">立即创建</el-button>
      <el-button v-else type="primary" size="mini" @click="next">下一步</el-button>
    </div>

    <!-- component -->
    <simpleAddCompany ref="simpleAddCompany" @confirm="addCompany"></simpleAddCompany>
    <!-- <ChooseCity ref="ChooseCity" :default="project.办公地" @confirm="val => confirmCity('办公地', val)"></ChooseCity> -->
  </div>
</template>

<script>
import { locations } from '../../constant/type'
import simpleAddCompany from './simpleAddCompany'
// import ChooseCity from './ChooseCity'
import iconSelect from './iconSelect'

export default {
  components: { simpleAddCompany, iconSelect },
  props: {
    hasCreated: Boolean,
  },
  data() {
    return {
      project: { 客户公司: '', 办公地: [], 优先级: 1 },
      categories: [],
      pickerOptions: {},
      partnerField: ['客户开发', '项目对接', '项目经理', '项目成员'],
      saving: false,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
    }
  },
  computed: {
    locations() {
      return locations
    },
    accounts() {
      return window.app.accounts || []
    },
  },
  watch: {},
  async mounted() {
    if (!app.categories) await app.getCats()
    if (!app.accounts) await app.getUsers()
    this.init()
    this.categories = app.categories
    this.getDefaultCompanies()
    this.setTimePicker()
  },
  methods: {
    next() {
      this.$emit('next')
    },
    setTimePicker() {
      // TODO：一天推荐，三天推荐，怎么算天数（是否包括今天），怎么提醒
      this.pickerOptions = {
        shortcuts: [
          {
            text: '一天推荐',
            onClick(picker) {
              picker.$emit('pick', new Date())
            },
          },
          {
            text: '三天推荐',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3)
              picker.$emit('pick', date)
            },
          },
        ],
      }
    },
    init() {
      this.project = {}
      this.partnerField.forEach(field => {
        this.$set(this.project, field, [''])
      })
      this.$set(this.project, '保密', false)
      this.$set(this.project, '独家', false)
      this.$set(this.project, 'indroduceTime', new Date().setTime(new Date().getTime() + 3600 * 1000 * 24 * 3))
      this.saving = false
    },
    toChooseCity() {
      this.$emit('toChooseCity', {
        default: this.project['办公地'],
        func: val => this.$set(this.project, '办公地', val),
      })
      // this.$refs.ChooseCity.open()
    },
    confirmCity(field, val) {
      this.project[field] = window._.cloneDeep(val)
    },
    selectPartnet(field) {
      const value = this.project[field] || []
      const length = value.length
      console.log(this.project)
      if (length === 0 || value[length - 1]) value.push('')
    },
    addPartner(field) {
      const value = this.project[field] || []
      value.push('')
    },
    removePartner(field, index) {
      const value = this.project[field] || []
      value.splice(index, 1)
      if (value.length === 0) value.push('')
    },
    async querySearch(queryString, cb) {
      const results = queryString ? await this.searchCompanyName(queryString) : this.defaultCompanies
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    async handleSelect(item) {
      if (item.value === '没找到，新建一家公司') {
        this.$refs.simpleAddCompany.open()
        this.project.客户公司 = ''
      } else {
        this.project.客户公司 = item.简称
        const { result } = await app.service('company').getCompany({ 简称: item.简称 })
        this.project.客户开发 = [result.客户开发]
      }
    },
    addCompany(companyName) {
      this.project.客户公司 = companyName
    },
    async searchCompanyName(name) {
      const res = await app.service('company').serchCompany(name)
      const sliceArr = res.data.slice(0, 10)
      const arr =
        res.status === 200 ? sliceArr.map(val => ({ value: `${val.简称}（${val.公司名称}）`, 简称: val.简称 })) : []
      arr.push({ value: '没找到，新建一家公司' })
      return arr
    },
    async getDefaultCompanies() {
      const res = await app.service('project').getDefaultCompanies()
      if (res.status === 'success')
        this.defaultCompanies = res.data.map(val => ({ value: `${val.简称}（${val.公司名称}）`, 简称: val.简称 }))
      else this.$message.error(res.msg)
    },
    async getProject() {
      try {
        const project = await app.service('project').fetch('SJc_qvex8')
        return project
      } catch (e) {
        console.log(e.message)
      }
    },
    async confirm() {
      const { partnerField } = this
      const project = window._.cloneDeep(this.project)
      if (!project.客户公司) return this.$message.error('请填写客户公司')
      if (!project.项目名称) return this.$message.error('请填写岗位名称')
      if (this.saving) return
      this.saving = true

      partnerField.forEach(field => {
        project[field] = project[field].filter(v => v)
      })
      try {
        const newproject = await window.app.service('project').insert(project)
        this.$message.success({
          message: '项目创建成功',
          duration: 1000,
        })
        // this.$emit('createProject', newProject)
        // this.$notify({
        //   title: `${project['项目名称']}创建成功`,
        //   type: 'success',
        //   message: '点击查看',
        //   onClick: () => {
        //     let a = document.createElement('a')
        //     a.style.display = 'none'
        //     a.target = '_blank'
        //     a.href = `/#/project20/${project._id}`
        //     a.click()
        //     a = null
        //   },
        // })

        // const newproject = await this.getProject()
        console.log(newproject)
        await app.getProjects()
        this.$emit('createProject', newproject)
      } catch (e) {
        this.$message.error(`项目创建失败 : ${e.message}`)
        console.error(e)
      }
      this.saving = false
    },
    async checkClose(func) {
      const project = window._.cloneDeep(this.project)
      if (project.客户公司 && project.项目名称) {
        this.$confirm('您当前正在创建项目，是否保存您已填写的数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            await this.confirm()
            func && func()
          })
          .catch(() => {
            this.$message.info('已取消')
            func && func()
          })
      } else func && func()
    },
  },
}
</script>
<style>
.blue-text {
  color: #409eff;
}
</style>
<style scoped src="../../../statistics/css/addProject.css"></style>
